<template>
    <div id="intro-section" class="d-flex">
        <span class="intro-text text-center">Você está avaliando:</span>
        <div class="intro-img-wrapper d-flex">
            <img
                :style="{
                    height: '100%',
                }"
                :src="`${productData.image}?auto=compress,format&q=65&w=550&h=824&fit=crop&crop=top`"
            />
        </div>
        <span class="intro-title text-center">{{ productData.product_name }}</span>
        <div class="h-divider" />
    </div>
</template>

<script>
    export default {
        name: 'IntroSection',
        props: {
            productData: {
                type: Object,
                required: true,
            },
        },
    };
</script>
